import React, { useState } from 'react';

interface EssayData {
    question: string;
    answer: string;
    essayBand: string;
    aiScore: string;
    avgDifference: number;
    id: string;
}

const EssayGradingTable = ({ caption, essayData }: { caption: string, essayData: EssayData[] }) => {
    const [expanded, setExpanded] = useState(essayData.map(() => false));

    const toggleExpanded = (index: number) => {
        const newExpanded = [...expanded];
        newExpanded[index] = !newExpanded[index];
        setExpanded(newExpanded);
    };

    return (
        <div className="bg-white rounded-lg shadow overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
                <caption className='pb-5'>{caption}</caption>
                <tbody className="divide-y divide-gray-200">
                    {essayData.map((essay, index) => (
                        <tr key={essay.id} className="flex flex-col md:table-row">
                            <td className="md:w-2/3 py-3 px-4 text-left">

                                <p className='mt-1 mb-1'>
                                    <q>
                                        {expanded[index] ? (
                                            <div>
                                                <div><b>Question:</b> <div className='font-normal'>{essay.question}</div></div>
                                                <div className='whitespace-pre-wrap mt-2 font-normal'>
                                                    <b>Answer:</b> {essay.answer}
                                                </div>
                                            </div>
                                        ) : `${essay.answer.substring(0, 200)}...`}
                                    </q>
                                </p>
                                <button className="underline text-xs text-blue-800 p-1" onClick={() => toggleExpanded(index)}>
                                    {expanded[index] ? 'Collapse' : 'Expand'} Essay
                                </button>
                                <button className="underline text-xs text-blue-800 p-1 ml-2" onClick={() => window.location.href = `/essay/${essay.id}`}>
                                    View Full AI Feedback ↗️
                                </button>
                            </td>
                            <td className="py-3 px-4 text-center md:w-1/9">{essay.essayBand}</td>
                            <td className="py-3 px-4 text-center md:w-1/9">{essay.aiScore}</td>
                            <td className="py-3 px-4 text-center md:w-1/9">
                                <span
                                    className={`${essay.avgDifference <= 0.5
                                        ? 'text-green-500'
                                        : 'text-yellow-500'
                                        }`}
                                >
                                    {essay.avgDifference}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default EssayGradingTable;
